import React from 'react';
import {
  ArrayField,
  FileInput,
  SingleFieldList,
} from 'react-admin';

import Box from '@mui/material/Box';

import EditFieldLayout from '../components/layout/EditFieldLayout';

const EditFileField = ({
  label,
  source,
  showEdit,
  children,
  accept,
  multiple = false,
}: {
  label: string | false;
  source: string;
  showEdit: boolean;
  children: React.ReactNode;
  accept: { [mime: string]: string[] };
  multiple?: boolean;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    inputElement={(
      <FileInput
        source={source}
        label={false}
        accept={accept}
        multiple={multiple}
        helperText={false}
      >
        {children}
      </FileInput>
    )}
    fieldElement={(
      <Box display="flex" flexShrink={1}>
        <ArrayField source={source}>
          <SingleFieldList direction="column" linkType={false} alignItems="flex-start">
            {children}
          </SingleFieldList>
        </ArrayField>
      </Box>
    )}
  />
);

export default EditFileField;
